/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { useState } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import partial from 'transmute/partial';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import H2 from 'UIComponents/elements/headings/H2';
import UIForm from 'UIComponents/form/UIForm';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import useUserInfo from '../../../access/useUserInfo';
import { getUserId } from '../../../data/schemas/userInfoSchema';
import { useMutation } from 'data-fetching-client';
import { EDIT_ASSET_SCHEDULE } from 'dashboard-lib/public/emails/emails';
import { ReportActionsFloatingAlertStore } from 'reporting-action-components/shared/ReportActionsFloatingAlertStore';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useTracker } from '../../../utils/hooks/useTracker';
import { EVENTS } from '../../../utils/usageTracker';
import { noop } from '../../shared/noop';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const assetSpecificTrackingPropsPropDefault = {};
const ChangeRecurringAssetOwnerModal = ({
  appUsageTracker,
  closeDialog,
  schedule,
  createAndOwnUsersLabels,
  onEditSuccess = noop,
  objectType,
  assetSpecificTrackingProps = assetSpecificTrackingPropsPropDefault,
  currentDialog
}) => {
  const usageTracker = useTracker(appUsageTracker);
  const [editAssetScheduleMutation] = useMutation(EDIT_ASSET_SCHEDULE);
  const {
    data: userInfo
  } = useUserInfo();
  const ownerId = String(schedule.ownerId);
  const currentUserId = String(getUserId(userInfo));
  const [selectedId, setSelectedId] = useState(ownerId);
  const ownerIsSelected = selectedId === ownerId;
  const displayedValue = createAndOwnUsersLabels.findIndex(({
    value
  }) => value === selectedId) >= 0 ? selectedId : null;
  const handleChange = ({
    target: {
      value
    }
  }) => {
    setSelectedId(value);
  };
  const handleSave = () => {
    if (usageTracker) {
      usageTracker.track(EVENTS.updateSavedRecurringShareAsset, Object.assign({
        object: currentDialog,
        actionType: 'save',
        action: 'change-owner',
        interactionSource: 'dialog',
        assetType: objectType.toLowerCase()
      }, assetSpecificTrackingProps));
    }
    const updatedSchedule = Object.assign({}, schedule, {
      ownerId: selectedId
    });
    editAssetScheduleMutation({
      variables: Object.assign({
        scheduledEmailId: updatedSchedule.id
      }, updatedSchedule)
    }).then(() => {
      ReportActionsFloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.alert.success",
          options: {
            emailName: schedule.nickname || schedule.subject
          }
        }),
        type: 'success'
      });
      onEditSuccess();
      closeDialog();
    }, () => {
      ReportActionsFloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.alert.failure"
        }),
        type: 'danger'
      });
      closeDialog();
    });
  };
  const AssignToMeButton = /*#__PURE__*/_jsx(UIButton, {
    use: "link",
    onClick: partial(handleChange, SyntheticEvent(String(currentUserId))),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.action.assignToMe"
    })
  });
  return /*#__PURE__*/_jsxs(UIModal, {
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: closeDialog
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.header"
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(UIForm, {
        onSubmit: handleSave,
        children: /*#__PURE__*/_jsx(UIFormControl, {
          label: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.owner",
            options: {
              dialog: currentDialog
            }
          }),
          children: /*#__PURE__*/_jsx(UISelect, {
            onChange: handleChange,
            options: createAndOwnUsersLabels,
            value: displayedValue,
            dropdownFooter: AssignToMeButton,
            placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.placeholder"
            })
          })
        })
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UITooltip, {
        disabled: !ownerIsSelected,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.alreadyOwner"
        }),
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: handleSave,
          disabled: ownerIsSelected,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.action.confirm"
          })
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: closeDialog,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.manageRecurringEmails.dialog.table.actionsDropdown.changeOwnerAction.action.cancel"
        })
      })]
    })]
  });
};
export default ChangeRecurringAssetOwnerModal;
ChangeRecurringAssetOwnerModal.propTypes = {
  appUsageTracker: PropTypes.object.isRequired,
  closeDialog: PropTypes.func.isRequired,
  schedule: PropTypes.object.isRequired,
  createAndOwnUsersLabels: PropTypes.array.isRequired,
  onEditSuccess: PropTypes.func,
  objectType: PropTypes.string.isRequired,
  assetSpecificTrackingProps: PropTypes.object,
  currentDialog: PropTypes.string
};